<template>
  <b-card no-body class="shadow h-100 flex-container grid-stack-item-content">
    <div slot="header">
      <window-header cmp-title="History tool" widget-name="history">
        <template slot="left-options">
          <b-button @click="showOpts" size="sm" variant="dark" type="dark"
                    class="headerSmallButton">
            <icon name="cogs" scale=".7"></icon>
          </b-button>
        </template>
      </window-header>
    </div>
    <div class="row pr-3 pl-3 pb-1 pt-1">
      <div class="col-6">
        <div class="d-flex">
          <b-form-input class="input-xs" v-model="identFilter"
                        type="text"
                        placeholder="filter by ident"></b-form-input>
          <b-btn @click="applyFilters" :disabled="!identFilter" class="btn-xs ml-2">Apply</b-btn>
        </div>
      </div>
      <div class="col-6">

      </div>


    </div>
    <div class="flex-full-height-3  pr-3 pl-3">
      <div class="flex-container w-100">
        <b-list-group class="w-100">
          <div v-for="(e, index) in entries" :key="e.stmt_date + '-' + index">
            <b-list-group-item class="w-100 p-1">
              <div class="row">
                <div class="col-6">
                  <small><b>{{e.stmt_date}}</b></small>
                </div>
                <div class="col-3">
                  <small>({{e.count}})</small>
                </div>
                <div class="col-3">
                  <a href="#" @click.prevent.stop="expandDate($event, e, index)"><small>{{e.expanded? 'Hide' : 'Expand'}}</small></a>
                </div>
              </div>

              <b-list-group v-if="e.details && e.expanded">
                <b-list-group-item v-for="(d, i) in e.details" :key="d.stmt_date + d.current_rec.last_modified_user + '_' + i">
                  <div class="row">
                    <div class="col-2">
                      <small class="text-small" v-html="d.stmt_date.replace('Z', '').replace('T', ' ')"></small>
                    </div>
                    <div class="col-2">
                      <div>
                        <small class="text-small">{{d.changes && d.changes.last_modified_user ?
                          d.changes.last_modified_user : d.current_rec.last_modified_user}}
                        </small>
                      </div>
                    </div>
                    <div class="col-2">
                      <small class="text-small">{{d.entity}}</small>
                    </div>
                    <div class="col-2">
                      <small class="text-small">{{d.changes && d.changes.ident ? d.changes.ident :
                        d.current_rec.ident}}
                      </small>
                    </div>
                    <div class="col-2">
                      <small class="text-small">{{d.table_operation}}</small>
                    </div>
                    <div class="col-2">
                      <small><a href="#"
                                @click.prevent.stop="showDiff(d.table_operation, d.changes, d.current_rec, d.entity, d.changes && d.changes.ident ? d.changes.ident : d.current_rec.ident)">diff</a>
                      </small>
                    </div>
                  </div>

                </b-list-group-item>
              </b-list-group>
            </b-list-group-item>


          </div>

        </b-list-group>
      </div>
    </div>
    <loading-overlay :show="loading"></loading-overlay>
    <window-footer></window-footer>
  </b-card>
</template>

<script>
  import WindowHeader from './common/WindowHeader'
  import WindowFooter from './common/WindowFooter'
  import moment from 'moment'
  import HistoryDiff from './HistoryDiff'
  import LoadingOverlay from './LoadingOverlay'
  import HistoryOpts from './HistoryOpts'

  export default {
    name: 'HistoryTool',
    components: {HistoryOpts, LoadingOverlay, HistoryDiff, WindowHeader, WindowFooter},
    data () {
      return {
        minDate: null,
        maxDate: null,
        entries: [],
        identFilter: null,
        loading: false,
        exapndedIndex: null
      }
    },
    mounted () {
      this.loadComments(() => {
        this.loadDateEntries()
      })
    },
    watch: {
      identFilter (val) {
        if (!val) {
          this.loadDateEntries()
        }
      },
      opts: {
        deep: true,
        handler () {
          let sd = this.$store.getters['project/historyOpts']['start_date']
          let ed = this.$store.getters['project/historyOpts']['end_date']
          let reg = /(\d{4})-(\d{2})-(\d{2})/

          if (!reg.test(sd) || !reg.test(ed)) {
            console.log('Invalid date format')
            return
          }
          // this.loadDateEntries(
          //   '1',
          //   sd,
          //   ed
          // )
        }
      }
    },
    methods: {
      expandDate (event, e, index) {

        if (e && e.expanded == false && this.expandedIndex != index) {
          this.loadByDate(event, e.stmt_date)
        }
        if (this.expandedIndex != index) {
          this.entries[index].expanded = false
        }
        this.expandedIndex = index
        e.expanded = !e.expanded
      },
      showDiff (op, changes, current, ent, ident) {
        let opts = {
          available: true,
          enabled: true,
          clazz: HistoryDiff,
          w: 3,
          h: 7,
          x: 3,
          y: 0,
          propsData: {
            operation: op,
            d: [changes, current],
            ident: [ent, ident].join(' ')
          },
          destroyable: true
        }

        this.$store.commit('cmp/update', {
          cmp: 'history-diff',
          payload: opts
        })
      },
      showOpts () {
        let opts = {
          available: true,
          enabled: true,
          clazz: HistoryOpts,
          w: 3,
          h: 5,
          x: 3,
          y: 0,
          propsData: {},
          destroyable: true
        }

        this.$store.commit('cmp/update', {
          cmp: 'history-opts',
          payload: opts
        })
      },
      applyFilters () {
        this.loadDateEntries()
      },
      loadDateEntries (agg, startDate, endDate, clb) {
        this.loading = true
        let ed = endDate ? moment(endDate) : moment(this.maxDate).add(2, 'days')
        let sd = startDate ? moment(startDate) : moment(this.maxDate).subtract(15, 'days')
        this.$http.get(`/api/projects/list-history-changes`, {
          params: {
            start_date: sd.format('YYYY-MM-DD'),
            end_date: ed.format('YYYY-MM-DD'),
            identFilter: this.identFilter,
            excludeAnonym: this.$store.getters['project/historyOpts']['excludeAnonym'],
            ops: this.$store.getters['project/historyOpts']['ops'].join(','),
            tables: this.$store.getters['project/historyOpts']['tables'].join(','),
            agg: agg === undefined ? 1 : agg,
            workpack_id: this.$store.getters['project/currentProject'].workpack.id
          }
        }).then(res => {
          this.$notify({
            title: 'SUCCESS',
            text: 'Load history entries complete',
            type: 'success'
          })
          this.loading = false
          if (clb) {
            clb.call(this, res.body)
          } else {
            this.entries = res.body
          }

        }, err => {
          this.loading = false
          this.$notify({
            title: 'ERROR',
            text: 'Failed to load history entries',
            type: 'error'
          })
        })
      },
      loadByDate (ev, d) {
        console.log(d)
        let sd = moment(d, 'DD-MM-YYYY').startOf('day')
        let ed = moment(d, 'DD-MM-YYYY').add(1, 'day')

        this.loadDateEntries('0', sd, ed, (data) => {
          this.entries.forEach(e => {
            if (e.stmt_date === d) {
              e.details = data
            }
          })
        })
      },
      loadComments (clb) {
        this.$http.get(`/api/redmine/issues/${this.commentIssueId}.json?include=journals`)
          .then(res => {
            if (res && res.body && res.body.issue) {
              let journals = res.body.issue.journals.filter(j => !!j.notes)
                .map(j => {
                  j.created_on_date = new Date(j.created_on).getTime()
                  return j
                }).filter(j => !isNaN(j.created_on_date))

              this.minDate = new Date(Math.min(...journals.map(d => d.created_on_date)))
              this.maxDate = new Date(Math.max(...journals.map(d => d.created_on_date)))

              this.$store.getters['project/historyOpts']['start_date'] = moment(this.maxDate).subtract(1,'month').format('YYYY-MM-DD')
              this.$store.getters['project/historyOpts']['end_date'] = moment(this.maxDate).add(1,'days').format('YYYY-MM-DD')

              clb && clb.call(this)
            }
          }, r => {
            this.$notify({
              title: 'ERROR',
              text: 'Could not get release redmine issue',
              type: 'error'
            })
          })
      }
    },
    computed: {
      commentIssueId () {
        // return 0
        return this.$store.getters['project/currentProject'].workpack.redmine_issue_id
      },
      opts () {
        return this.$store.getters['project/historyOpts']
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/HistoryTool.vue